import React, { useState } from "react";
import { useStandard } from "../../../context/StandardContext";
import { useParams } from "react-router-dom";
import ViewTableIndex from "../../../components/View/ViewTableIndex";
import UseGetData from "../../../hooks/useFetchData";
import { PaperClip } from "../../../assets/icons";
import NuDateFormat from "../../../utils/NuDate";
import useGetStatusData from "../../../hooks/useGetStatusData";
import useDashboardStatus from "../../../hooks/useDashboardStatus";
import CreateOrEdit from "./from";
import useFetchMetaData from "../../../hooks/useFetchMetaData";
import ViewMore from "./viewMore";
import CommonXlsExport from "../../../utils/CommonXlsExport";
import useGetStandardDetail from "../../../hooks/useGetStandardDetail";
import CommonImport from "../../../utils/CommonImport";

function SecurityIncidentIndex() {
  const { standardName } = useStandard();
  const { stdId } = useParams();
  const {statusValue} = useGetStatusData({value:12})
  const { metaData} = useFetchMetaData({value: "incident_type"});
  const { completePercentage,getData:getDashboardData} = useDashboardStatus({url:`/DashBoard/standard/${stdId}/security-incident/`})
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const { data, totalCount, getData, isLoading } = UseGetData({
    url: `/Security-Incident/standard/${stdId}`,
    page: pageIndex,
    pageCount: dataCount,
  });
  const {standardDetailName,standardStartDate,standardEndDate} = useGetStandardDetail({id:stdId})
  const [showExport,setShowExport] = useState(false);
  const [showImport,setShowImport] = useState(false);
  return (
    <>
      <ViewTableIndex
        label="Security Incident"
        menu="Information"
        standardName={standardName}
        total={totalCount}
        setDataCount={setDataCount}
        dataCount={dataCount}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        setOpenForm={setShowMyModal}
        Access="information_create"
        hasOverAll={true}
        OverAllPercentage={completePercentage}
        header={header}
        isLoading={isLoading}
        ExportAccess="export"
        ExportFunction={()=>setShowExport(true)}
        hasExport={true}
        ImportAccess="import"
        ImportFunction={()=>setShowImport(true)}
        hasImport={true}
      >
        <>
        {data &&
    data?.map((data, i) => (
      <tr
        className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
        key={i}
      >
        <td className="px-2 py-1 text-gray-900 whitespace-nowrap text-center w-[5%] capitalize">
          {data.serial_number || "#"}
        </td>
        <td className="px-2 py-1 text-center text-gray-900 w-[16%] capitalize ">
          {data?.systems || "-"}
        </td>
        <td className="px-2 py-1 text-center text-gray-900 w-[9%] capitalize ">
          {(data?.incident_date !== "None" &&
            data?.incident_date !== " " &&
            NuDateFormat({
              value: data?.incident_date,
              format: "DD-MMM-yyyy",
            })) ||
            "-"}
        </td>
        <td className="px-2 py-1 text-center text-gray-900 w-[9%] capitalize ">
          {(data?.closure_date !== "None" &&
            data?.closure_date !== " " &&
            NuDateFormat({
              value: data?.closure_date,
              format: "DD-MMM-yyyy",
            })) ||
            "-"}
        </td>
        <td className="px-2 py-1 text-center text-gray-900 w-[15%] capitalize ">
          {data?.type_of_incident || "-"}
        </td>
        <td className="px-2 py-1 text-center text-gray-900 w-[17%] capitalize ">
          {data?.RCA || "-"}
        </td>
        <td className="px-2 py-1 text-center capitalize text-gray-900 w-[9%] ">
          {data?.status || "-"}
        </td>
        <td className="px-2 py-1 text-center text-gray-900 w-[17%] capitalize flex justify-center items-center">
          {data?.incident_report.length > 0 && <PaperClip />}
        </td>
        <td className="px-2 py-1 w-[3%] flex justify-center items-center">
          <ViewMore
          data={data}
          metaData={metaData}
          satusData={statusValue}
          fetcher={getData}
          getCompletion={getDashboardData}
          id={stdId}
        />
        </td>
      </tr>
    ))}
        </>
      </ViewTableIndex>
      <CreateOrEdit
         visible={showMyModal}
         onClose={handleOnClose}
         refreshData={getData}
         metaData={metaData}
         satusData={statusValue}
         getCompletion={getDashboardData}
         id={stdId}
      />
      <CommonXlsExport 
        id={stdId}
        path={`security_incident`}
        name={`${standardDetailName} Security Incident ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`}
        visible={showExport}
        onClose={()=>{setShowExport(false)}}/>

        <CommonImport 
         url={`/Security-Incident/standard/${stdId}/import`} 
         refreshData={getData} 
         getFuction={getDashboardData} 
         visible={showImport} 
         onClose={()=>setShowImport(false)}
         />
    </>
  );
}

export default SecurityIncidentIndex;

const header = [
  {
    headone: <span>Sl&nbsp;No.</span>,
    width: "w-[5%]",
  },
  {
    headone: "System",
    width: "w-[16%]",
  },
  {
    headone: "Incident Date",
    width: "w-[9%]",
  },
  {
    headone: "Closure Date",
    width: "w-[9%]",
  },
  {
    headone: "Type of Incident",
    width: "w-[15%]",
  },
  {
    headone: "RCA Information / Analysis",
    width: "w-[17%]",
  },
  {
    headone: "Status Update",
    width: "w-[9%]",
  },
  {
    headone: "Incident Report / ATR Report",
    width: "w-[17%]",
  },
  {
    headone: " ",
    width: "w-[3%]",
  },
];

